// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as TailwindMerge from "tailwind-merge";
import * as Uuid$LiteracyplanetTupperware from "../Uuid.res.mjs";
import * as StopIcon$LiteracyplanetTupperware from "../v2/StopIcon.res.mjs";
import * as VolumeIcon$LiteracyplanetTupperware from "../v2/VolumeIcon.res.mjs";
import * as SpinnerIcon$LiteracyplanetTupperware from "../v2/SpinnerIcon.res.mjs";
import * as AudioButtonApi$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/AudioButtonApi.res.mjs";
import * as SoundProviderEmbedded$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/SoundProviderEmbedded.res.mjs";

function V3AudioEmbeddedComponent$ButtonContainer(props) {
  var onTogglePlay = props.onTogglePlay;
  return React.createElement("div", {
              className: "AudioQueryComponentButtonContainer",
              onClick: (function (evt) {
                  onTogglePlay();
                  evt.stopPropagation();
                })
            }, props.children);
}

var ButtonContainer = {
  make: V3AudioEmbeddedComponent$ButtonContainer
};

function V3AudioEmbeddedComponent$PlayAudioIcon(props) {
  var className = props.className;
  var classNameClick = TailwindMerge.twMerge(className, "cursor-pointer");
  switch (props.state) {
    case "Loading" :
        return React.createElement(SpinnerIcon$LiteracyplanetTupperware.make, {
                    className: className
                  });
    case "Stopped" :
        return React.createElement(VolumeIcon$LiteracyplanetTupperware.make, {
                    className: classNameClick
                  });
    case "Playing" :
        return React.createElement(StopIcon$LiteracyplanetTupperware.make, {
                    className: classNameClick
                  });
    
  }
}

var PlayAudioIcon = {
  make: V3AudioEmbeddedComponent$PlayAudioIcon
};

function V3AudioEmbeddedComponent$V3AudioEmbeddedComponent(props) {
  var children = props.children;
  var audioId = props.audioId;
  var instance = React.useMemo((function () {
          return Uuid$LiteracyplanetTupperware.make();
        }), [audioId]);
  var match = SoundProviderEmbedded$LiteracyplanetClientFlags.use(instance, audioId, false, props.sources);
  var onTogglePlay = match[1];
  return React.createElement("div", undefined, React.createElement(AudioButtonApi$LiteracyplanetClientFlags.make, {
                  isPlaying: match[0],
                  src: match[2],
                  onEnd: (function () {
                      Curry._1(onTogglePlay, undefined);
                    }),
                  onTogglePlay: onTogglePlay,
                  children: (function (state, onTogglePlay) {
                      return React.createElement(V3AudioEmbeddedComponent$ButtonContainer, {
                                  onTogglePlay: (function () {
                                      Curry._1(onTogglePlay, undefined);
                                    }),
                                  children: children(state)
                                });
                    })
                }));
}

var V3AudioEmbeddedComponent = {
  make: V3AudioEmbeddedComponent$V3AudioEmbeddedComponent
};

function V3AudioEmbeddedComponent$WithButtonAndSources(props) {
  var sources = props.sources;
  if (sources !== undefined) {
    return React.createElement(V3AudioEmbeddedComponent$V3AudioEmbeddedComponent, {
                audioId: props.audioId,
                sources: sources,
                autoPlay: false,
                children: (function (state) {
                    return React.createElement(V3AudioEmbeddedComponent$PlayAudioIcon, {
                                className: "pilot-audio",
                                state: state
                              });
                  })
              });
  } else {
    return null;
  }
}

var WithButtonAndSources = {
  make: V3AudioEmbeddedComponent$WithButtonAndSources
};

export {
  ButtonContainer ,
  PlayAudioIcon ,
  V3AudioEmbeddedComponent ,
  WithButtonAndSources ,
}
/* react Not a pure module */
